import React from "react";
import { CenterView } from "../packages";
import ResponsiveDrawer from "./ResponsiveDrawer";
import { Outlet } from "react-router-dom";
import UpgradeModal from "./UpgradeModal";
import { RootState } from "../redux/store";
import { connect } from "react-redux";
import { UserDetails } from "../modules/ProfileModule/store/profile.types";
import { GetSubscriptionsAllPlans } from "../modules/BillingModule/store/billing.types";

const mapStateToProps = (state: RootState) => {
  const { getUserReducers, getSubscriptionsAllPlansReducers } = state;
  return {
    data: getSubscriptionsAllPlansReducers.data,
    userDetails: getUserReducers.userDetails,
  };
};

type Props = {
  isNav?: boolean;
  userDetails: UserDetails;
  data: GetSubscriptionsAllPlans;
};

const Layout = React.memo(({ isNav, userDetails, data }: Props) => {
  const isPlan = userDetails?.userPlan === "free";
  return (
    <>
      {isNav ? (
        <CenterView>
          {isPlan && userDetails.role !== "testosteronologist" && (
            <UpgradeModal
              open={true}
              close={() => console.log("Upgrade modal closed")}
              title="Upgrade Your Plan"
              data={data}
              showCloseButton={false}
            />
          )}
          <ResponsiveDrawer>
            <Outlet />
          </ResponsiveDrawer>
        </CenterView>
      ) : (
        <CenterView>
          <Outlet />
        </CenterView>
      )}
    </>
  );
});

export default connect(mapStateToProps)(Layout);
